export default {
  getTemplateDesign(state) {
    return state.templateDesign;
  },
  getTemplateData(state) {
    return state.templateData;
  },
  getFormData(state) {
    return state.formData;
  },
  getTemplates(state) {
    return state.templates;
  },
  getCampaigns(state) {
    return state.campaigns;
  },
  getTemplate(state) {
    return state.template;
  },
  getSegments(state) {
    return state.segments;
  },
  getSegment(state) {
    return state.segment;
  },
  getSegmentObj(state) {
    return state.segmentObj;
  },
  getSegment2(state) {
    console.log(state.segment);
    let items = state.segment;
    // console.log("items", items);
    // console.log("items.segment_groups", items.segment_groups);
    let data = [];
    items.segment_groups.map(item => {
      // console.log(item.id);
      // console.log(item.segment_rules);
      data.push({
        uuid: item.id,
        rules: item.segment_rules
      });
    });
    console.log("data", data);
    return data;
  },
  getSegmentSubscribers(state) {
    return state.segmentSubscribers;
  },
  getSegmantAddDialog(state) {
    return state.segmentAddDialog;
  },
  getSegmantUpdateDialog(state) {
    return state.segmentUpdateDialog;
  },
  getSegmantCloneDialog(state) {
    return state.segmentCloneDialog;
  },
  getSegmentGroups(state) {
    return state.segmentGroups;
  },
  getHasChanges(state) {
    return state.hasChanges;
  },
  getFlows(state) {
    return state.flows;
  },
  getFlowId(state) {
    return state.setFlowId;
  },
  getFlowSequence(state) {
    return state.flowSequence;
  },
  getInitialMenuItem(state) {
    return state.initialMenuItems;
  },
  getUpdateCampaign(state) {
    return state.updateCampaign;
  },
  getUpdateOtherCampaign(state) {
    return state.updateOtherCampaign;
  },
  getCampaignItem(state) {
    return state.campaignItem;
  },
  getOtherCampaignItem(state) {
    return state.otherCampaignItem;
  },
  getOtherCampaignItems(state) {
    return state.otherCampaignItems;
  }
};
